import axios from 'axios';
import { toast } from 'react-toastify';

export const AUTH_ERROR_EVENT = 'APP_AUTH_ERROR_EVENT';

const API_URL = 'https://api-dev.regtechflow.net/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json',
  }
});

apiClient.interceptors.request.use((config) => {
  if (config.headers) {
    config.headers['Accept'] = 'application/json';
    config.headers['Content-Type'] = 'application/json';
  }
  if (config.data && typeof config.data.body === 'string') {
    config.data.body = config.data.body.substring(0, 255);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      switch (status) {
        case 400: {
          const errors = error.response.data?.errors;
          if (errors) {
            const errorMessages = `${Object.keys(errors).flat().join('')}: ${Object.values(errors)
              .flat()
              .join(' | ')}`;
            toast.error(errorMessages || 'Invalid input provided', {
              hideProgressBar: true,
              autoClose: 3000,
            });
          } else {
            toast.error('Invalid request. Please check the input values.', {
              hideProgressBar: true,
              autoClose: 3000,
            });
          }
          break;
        }
        case 401:
          document.dispatchEvent(new CustomEvent(AUTH_ERROR_EVENT));
          break;
        case 404:
          toast.error('The requested resource could not be found.', { hideProgressBar: true });
          break;
        case 409:
          toast.error(error.response.data, { hideProgressBar: true });
          break;
        case 500:
          toast.error('Internal server error', { hideProgressBar: true });
          break;
        default:
          console.error('Unhandled error status:', status);
          break;
      }
    } else {
      console.error('Unknown error:', error);
    }
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return apiClient.get(url, config).then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return apiClient.post(url, data, config).then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return apiClient.put(url, data, config).then((response) => response.data);
}

export async function del(url, config = {}) {
  return apiClient.delete(url, config).then((response) => response.data);
}

export default apiClient;
